<template>
  <ValidationObserver ref="observer">
    <v-form @submit="handleSearch">
      <GenericTitle center title="Generar ticket" :subtitle="subtitleForm" />
      <div class="input-document">
        <ValidationProvider
          v-slot="{ errors }"
          name="Tipo de documento"
          rules="required"
        >
          <SelectInput
            v-model="form.documentType"
            :items="listOfDocuments"
            label="Tipo de documento"
            item-value="id"
            item-text="name"
            outlined
            dense
            :error-messages="errors"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Documento"
          :rules="`required|numeric|min:${documentValidation}|max:${documentValidation}`"
        >
          <TextInput
            name="document"
            label="Documento"
            type="text"
            outlined
            dense
            v-model="form.document"
            :error-messages="errors"
            :max-length="documentValidation"
          />
        </ValidationProvider>
      </div>
      <div class="button-search">
        <BasicButton
          class="mt-2"
          color="primary"
          type="submit"
          :loading="loading"
          text="Buscar"
          iconOrientation="right"
          icon="mdi-search-web"
        />
      </div>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { getDocumentValidation } from '@/domain/ticket/ticket.model';
import GenericTitle from '@/infrastructure/vue/components/common/titles/GenericTitle';
import SelectInput from '@/infrastructure/vue/components/common/inputs/SelectInput.vue';
import TextInput from '@/infrastructure/vue/components/common/inputs/TextInput';
import BasicButton from '@/infrastructure/vue/components/common/buttons/BasicButton';
import { required, numeric, min, max } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'El campo {_field_} es obligatorio',
});
extend('numeric', {
  ...numeric,
  message: 'El campo {_field_} solo debe contener números',
});
extend('min', {
  ...min,
  message: 'El campo {_field_} debe contener mínimo {length} caracteres',
});
extend('max', {
  ...max,
  message: 'El campo {_field_} debe contener máximo {length} caracteres',
});
export default {
  name: 'ValidateDocumentForm',
  components: {
    GenericTitle,
    SelectInput,
    TextInput,
    BasicButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    subtitleForm: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  computed: {
    documentValidation() {
      return getDocumentValidation(this.form.documentType);
    },
  },
  data: () => ({
    listOfDocuments: [
      {
        id: 1,
        name: 'DNI',
      },
      {
        id: 2,
        name: 'CE',
      },
      {
        id: 3,
        name: 'RUC',
      },
    ],
    form: {
      documentType: null,
      document: '',
    },
  }),
  methods: {
    async handleSearch(e) {
      e.preventDefault();
      const isValidateForm = await this.$refs.observer.validate();
      if (isValidateForm) {
        this.$emit('onSearch', this.form);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-document {
  padding-top: 20px;
  max-width: 300px;
  margin: 0 auto;
}
.button-search {
  max-width: 160px;
  margin: 0 auto;
}
</style>
